export default {"src":"/_next/static/media/ios-share.ad9dce5a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};